export default __webpack_public_path__ + "static/media/legend_1280.aa444bf4.webp";